module.exports = __webpack_public_path__ + "static/media/live.66adfccf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/SkywalletLanding/images/live.jpg
// module id = 1164
// module chunks = 0